module.exports = __webpack_public_path__ + "static/media/masks_KN95_FFP2.f89d7e54.svg";